module.exports = "<app-confirmation-view></app-confirmation-view>\r\n\r\n<div class=\"row mb-3\">\r\n  <div class=\"col\">\r\n    <app-activate-port-call></app-activate-port-call>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-content/content-container/port-call/confirmation/confirmation.component.html
// module id = ./src/app/main-content/content-container/port-call/confirmation/confirmation.component.html
// module chunks = main